module.exports = __webpack_public_path__ + "img/icon／qsy／jsz.c62d6cc4.png";